import Select from "react-select";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAssetType, setOnBoard, setDestination, setShip, clearAssetType, clearOnBoard, clearDestination, clearShip } from "../../../Reducers/galleryReducer";
import "./SelectButton.css"

const SelectButton = ({ options = [], placeholder, isClearable = true }) => {
    const [selectOptions, setSelectOptions] = useState([]);

    const dispatch = useDispatch();

    useEffect(() => {
        let optionsList = options;

        if (placeholder === "Image & Video") {
            optionsList = [
                { asset_type: "media", title: "Image & Video" },
                { asset_type: "image", title: "Image" },
                { asset_type: "video", title: "Video" }
            ];
        }

        const formattedOptions = optionsList.map(item => ({
            value: item.asset_type || item,
            label: item.title || item
        }));

        setSelectOptions(formattedOptions);
    }, []);

    const handleSelectChange = (selectedOption) => {
        const actionMap = {
            "Ship": selectedOption ? setShip(selectedOption.value) : clearShip(),
            "Macro Area": selectedOption ? setDestination(selectedOption.value) : clearDestination(),
            "On Board": selectedOption ? setOnBoard(selectedOption.value) : clearOnBoard(),
            "Image & Video": selectedOption ? setAssetType(selectedOption.value) : clearAssetType(),
        };

        if (actionMap[placeholder]) {
            dispatch(actionMap[placeholder]);
        } else {
            console.log("Placeholder non riconosciuto:", placeholder);
        }
    };

    return (
        <div className='h-100 select-col'>
            <Select
                options={selectOptions}
                onChange={handleSelectChange}
                isClearable={isClearable}
                placeholder={placeholder}
                className="basic-single select-custom"
                classNamePrefix="select"
            />
        </div >
    );
};

export default SelectButton;